document.addEventListener('DOMContentLoaded', () => {
  const FREE_WORDS = ['offert', 'offered', 'free', 'gratis', 'gratuit', 'kostenlos', 'included', 'inclus'];
  const freeWordRegex = new RegExp(`\\b(?:${FREE_WORDS.join('|')})`, 'i');

  const OUT_CLASS = 'tcustomizer-price-fmt';
  const ON_CLASS = 'tcustomizer-price-fmt-on';
  const SRC_ATTR = 'data-tc-price-src';

  // The app owns the original spans and keeps patching them, so they stay in the DOM
  // as the source of truth and are hidden with CSS instead of being overwritten.
  const style = document.createElement('style');
  style.textContent = `.${ON_CLASS} > *:not(.${OUT_CLASS}) { display: none; }`;
  document.head.appendChild(style);

  const span = (className, text) => {
    const el = document.createElement('span');
    el.className = className;
    el.textContent = text;
    return el;
  };

  const buildParts = (right, addonText) => {
    const freeMatch = right.match(freeWordRegex);

    if (freeMatch) {
      const oldPrice = right.slice(0, freeMatch.index).trim();
      const freeText = right.slice(freeMatch.index).trim();

      return [
        oldPrice ? span('tcustomizer-price-old', oldPrice) : null,
        span('tcustomizer-price-offert', freeText),
      ].filter(Boolean);
    }

    if (addonText) {
      return [
        span('tcustomizer-price-old', right),
        span('tcustomizer-price-new', addonText),
      ];
    }

    return null;
  };

  const styleContainer = (container) => {
    // The original first span, not the node this script appends.
    const source = container.querySelector(`:scope > *:not(.${OUT_CLASS})`);
    if (!source) return;

    const raw = source.textContent.trim();

    // Already rendered for exactly this text: nothing changed, nothing to do. Set on
    // every outcome including the unparseable one, so a container is only ever
    // examined once per distinct source text.
    if (container.getAttribute(SRC_ATTR) === raw) return;
    container.setAttribute(SRC_ATTR, raw);

    const parts = raw.split('|');
    const priceParts = parts.length < 2
      ? null
      : buildParts(parts.slice(1).join('|').trim(), container.querySelector('.tcustomizer-addon')?.textContent.trim() || '');

    const existing = container.querySelector(`:scope > .${OUT_CLASS}`);

    if (!priceParts) {
      // Fall back to whatever the app rendered rather than showing a stale price.
      if (existing) existing.remove();
      container.classList.remove(ON_CLASS);
      return;
    }

    const out = existing || span(OUT_CLASS, '');
    out.replaceChildren(span('tcustomizer-title', parts[0].trim()), document.createTextNode(' | '), ...priceParts);

    if (!existing) container.appendChild(out);
    container.classList.add(ON_CLASS);
  };

  let root = null;

  const styleCheckboxLabels = () => {
    if (!root) return;
    root.querySelectorAll('.tcustomizer-checkbox__label-value').forEach(styleContainer);
  };

  let styleRaf = null;

  const scheduleStyle = () => {
    if (styleRaf) return;
    styleRaf = requestAnimationFrame(() => {
      styleRaf = null;

      if (root && !root.isConnected) {
        observer.disconnect();
        armTries = 0;
        armObserver();
        return;
      }

      styleCheckboxLabels();
      // Discard the mutations this pass just caused so they don't schedule another one.
      observer.takeRecords();
    });
  };

  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      // Ignore this script's own output subtree.
      const target = m.type === 'characterData' ? m.target.parentElement : m.target;
      if (target?.closest?.(`.${OUT_CLASS}`)) continue;

      scheduleStyle();
      return;
    }
  });

  let armTries = 0;

  const armObserver = () => {
    const target = document.querySelector('[id^="tcustomizer-form-container"]')
      || document.querySelector('[id^="tcustomizer-form-"]')
      || document.querySelector('.tcustomizer');

    if (target) {
      root = target;
      observer.observe(target, { childList: true, subtree: true, characterData: true });
      scheduleStyle();
      return;
    }

    // Never fall back to observing document.body: on this storefront that is a
    // mutation firehose from the other apps on the page.
    if (++armTries < 50) setTimeout(armObserver, 200);
  };

  armObserver();
});
